// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hAkRdHOCTmI5YaWucrq1 {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.n2qZxH7bgLqPTjfS7rTJ {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--dst-text);
}

.Ly0_mON3oKXuVaG_iodV {
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 6px;
  font-size: 1em;
  border: 1px solid transparent;
}

.Ly0_mON3oKXuVaG_iodV.uHg9eGMn1zAEiWzfWZdQ {
  background: var(--dst-error-bg);
  color: var(--dst-error-text);
  border-color: var(--dst-error-border);
}

.RujUGx56pVO19CpccZ1E {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.Hcv5_5fi2NnF3zd4Lo85 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.gvMARHKqtn3zRNIEsQVo {
  font-weight: 600;
  font-size: 0.9em;
  color: var(--dst-text);
}

.hFO2612hetxtble56fjv {
  min-height: 44px;
  padding: 6px 8px;
  border: 1px solid var(--dst-input-border);
  border-radius: 4px;
  font-size: 0.95em;
  color: var(--dst-text);
  background: var(--dst-input-bg);
}

.joXgeHBkEO2DBDJVar8h {
  padding: 10px;
  text-align: left;
  font-size: 0.88rem;
  color: var(--dst-muted);
}

.T6K7vLFawcRYd8OTgyX9,
.dKiMHAUZ1qG6_pw4Uc8I {
  color: var(--dst-muted);
  text-align: center;
  padding: 20px;
  font-style: italic;
}

.yN6nVuepLfZ9cmS2YtmO {
  overflow-x: auto;
  border: 1px solid var(--dst-table-border);
  border-radius: 8px;
}

.P8UaQePSLkWrekqf6rcE {
  width: 100%;
  border-collapse: collapse;
  background: var(--dst-table-bg);
}

.P8UaQePSLkWrekqf6rcE thead {
  background: var(--dst-table-head-bg);
  color: var(--dst-table-head-text);
}

.P8UaQePSLkWrekqf6rcE th {
  padding: 10px;
  text-align: left;
  font-weight: 700;
  border-bottom: 2px solid var(--dst-table-border);
}

.P8UaQePSLkWrekqf6rcE td {
  padding: 10px;
  border-bottom: 1px solid var(--dst-table-border);
}

.P8UaQePSLkWrekqf6rcE tbody tr:hover {
  background: var(--dst-panel-subtle);
}

.Zk_S5puO9BSEz6cqTv4U {
  font-weight: 600;
  color: var(--dst-primary);
}

.KrfoMS5qXm72lBoyroyB {
  font-size: 0.9em;
  color: var(--dst-muted);
}

/* Quick range preset buttons */
.FKgMH83b5nX12QvjC6V8 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.I5j9T_El9D_aH0dKaJi3 {
  padding: 6px 14px;
  font-size: 0.9em;
  font-weight: 600;
  border: 1px solid var(--dst-border);
  border-radius: 20px;
  background: var(--dst-card-bg);
  color: var(--dst-text);
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
}

.I5j9T_El9D_aH0dKaJi3:hover {
  background: var(--dst-primary);
  color: #fff;
  border-color: var(--dst-primary);
}

/* Grouped table rows */
.YU8GoRfHQhbqDKcdDs_U {
  background: var(--dst-table-head-bg);
  font-weight: 700;
}

.YU8GoRfHQhbqDKcdDs_U:hover {
  background: var(--dst-table-head-bg);
}

.D_eHrMrTyvMmTJsoxNBA {
  font-weight: 700;
  color: var(--dst-text);
  text-transform: uppercase;
  font-size: 0.88em;
  letter-spacing: 0.04em;
}

.D_HljZhn3IRmJoBBpRCA {
  font-weight: 700;
  color: var(--dst-primary);
}

.XhBXiq5yHmJiMDgxzKJw {
  color: var(--dst-muted);
  font-size: 0.95em;
}

@media (max-width: 768px) {
  .hAkRdHOCTmI5YaWucrq1 {
    padding: 12px;
  }

  .n2qZxH7bgLqPTjfS7rTJ {
    font-size: 1.3em;
  }

  .RujUGx56pVO19CpccZ1E {
    flex-direction: column;
  }

  .Hcv5_5fi2NnF3zd4Lo85 {
    flex: 1;
  }

  .P8UaQePSLkWrekqf6rcE th,
  .P8UaQePSLkWrekqf6rcE td {
    padding: 8px;
    font-size: 0.9em;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/components/OfficerDashboard/tabs/MyStats.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,OAAO;EACT;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.title {\n  font-size: 1.5em;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: var(--dst-text);\n}\n\n.alert {\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  font-size: 1em;\n  border: 1px solid transparent;\n}\n\n.alert.error {\n  background: var(--dst-error-bg);\n  color: var(--dst-error-text);\n  border-color: var(--dst-error-border);\n}\n\n.filterBar {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.label {\n  font-weight: 600;\n  font-size: 0.9em;\n  color: var(--dst-text);\n}\n\n.input {\n  min-height: 44px;\n  padding: 6px 8px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 4px;\n  font-size: 0.95em;\n  color: var(--dst-text);\n  background: var(--dst-input-bg);\n}\n\n.caption {\n  padding: 10px;\n  text-align: left;\n  font-size: 0.88rem;\n  color: var(--dst-muted);\n}\n\n.loading,\n.empty {\n  color: var(--dst-muted);\n  text-align: center;\n  padding: 20px;\n  font-style: italic;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n  border: 1px solid var(--dst-table-border);\n  border-radius: 8px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--dst-table-bg);\n}\n\n.table thead {\n  background: var(--dst-table-head-bg);\n  color: var(--dst-table-head-text);\n}\n\n.table th {\n  padding: 10px;\n  text-align: left;\n  font-weight: 700;\n  border-bottom: 2px solid var(--dst-table-border);\n}\n\n.table td {\n  padding: 10px;\n  border-bottom: 1px solid var(--dst-table-border);\n}\n\n.table tbody tr:hover {\n  background: var(--dst-panel-subtle);\n}\n\n.value {\n  font-weight: 600;\n  color: var(--dst-primary);\n}\n\n.notes {\n  font-size: 0.9em;\n  color: var(--dst-muted);\n}\n\n/* Quick range preset buttons */\n.quickRanges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n.quickBtn {\n  padding: 6px 14px;\n  font-size: 0.9em;\n  font-weight: 600;\n  border: 1px solid var(--dst-border);\n  border-radius: 20px;\n  background: var(--dst-card-bg);\n  color: var(--dst-text);\n  cursor: pointer;\n  transition: background 0.12s, border-color 0.12s;\n}\n\n.quickBtn:hover {\n  background: var(--dst-primary);\n  color: #fff;\n  border-color: var(--dst-primary);\n}\n\n/* Grouped table rows */\n.totalRow {\n  background: var(--dst-table-head-bg);\n  font-weight: 700;\n}\n\n.totalRow:hover {\n  background: var(--dst-table-head-bg);\n}\n\n.totalLabel {\n  font-weight: 700;\n  color: var(--dst-text);\n  text-transform: uppercase;\n  font-size: 0.88em;\n  letter-spacing: 0.04em;\n}\n\n.totalValue {\n  font-weight: 700;\n  color: var(--dst-primary);\n}\n\n.periodLabel {\n  color: var(--dst-muted);\n  font-size: 0.95em;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 12px;\n  }\n\n  .title {\n    font-size: 1.3em;\n  }\n\n  .filterBar {\n    flex-direction: column;\n  }\n\n  .filterGroup {\n    flex: 1;\n  }\n\n  .table th,\n  .table td {\n    padding: 8px;\n    font-size: 0.9em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hAkRdHOCTmI5YaWucrq1`,
	"title": `n2qZxH7bgLqPTjfS7rTJ`,
	"alert": `Ly0_mON3oKXuVaG_iodV`,
	"error": `uHg9eGMn1zAEiWzfWZdQ`,
	"filterBar": `RujUGx56pVO19CpccZ1E`,
	"filterGroup": `Hcv5_5fi2NnF3zd4Lo85`,
	"label": `gvMARHKqtn3zRNIEsQVo`,
	"input": `hFO2612hetxtble56fjv`,
	"caption": `joXgeHBkEO2DBDJVar8h`,
	"loading": `T6K7vLFawcRYd8OTgyX9`,
	"empty": `dKiMHAUZ1qG6_pw4Uc8I`,
	"tableWrapper": `yN6nVuepLfZ9cmS2YtmO`,
	"table": `P8UaQePSLkWrekqf6rcE`,
	"value": `Zk_S5puO9BSEz6cqTv4U`,
	"notes": `KrfoMS5qXm72lBoyroyB`,
	"quickRanges": `FKgMH83b5nX12QvjC6V8`,
	"quickBtn": `I5j9T_El9D_aH0dKaJi3`,
	"totalRow": `YU8GoRfHQhbqDKcdDs_U`,
	"totalLabel": `D_eHrMrTyvMmTJsoxNBA`,
	"totalValue": `D_HljZhn3IRmJoBBpRCA`,
	"periodLabel": `XhBXiq5yHmJiMDgxzKJw`
};
export default ___CSS_LOADER_EXPORT___;
